module.exports = __webpack_public_path__ + "static/img/ad13.c8704fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad13.png
// module id = hKAI
// module chunks = 12